import BackendApiConsumer from "apiConsumers/backendApiConsumer/BackendApiConsumer";
import NewsApiConsumer from "apiConsumers/newsApiConsumer/NewsApiConsumer";
import KenticoApiConsumer from "apiConsumers/kenticoApiConsumer/KenticoApiConsumer";

const baseUrl = window.location.protocol + "//" + window.location.host;

const { PUBLIC_URL } = process.env;

const rootUrl = `${baseUrl}${PUBLIC_URL}/api`;

export const backendApi = new BackendApiConsumer({ rootUrl });
export const newsApi = new NewsApiConsumer({ rootUrl });
export const kenticoApi = new KenticoApiConsumer({ rootUrl });
